<!--
  Hash Mentions List Component
  
  Simple wrapper that uses the unified MentionsList component
  for consistent UI with tool-based mentions.
-->

<script setup lang="ts">
  import { ref } from 'vue'

  import MentionsList from './MentionsList.vue'

  interface MentionItem {
    id: string
    label: string
    type: 'channel' | 'event' | 'user' | 'course'
    [key: string]: unknown
  }

  const props = defineProps({
    query: {
      type: String,
      default: '',
    },
    command: {
      type: Function,
      required: true,
    },
  })

  // Reference to MentionsList for keyboard handling
  const mentionsListRef = ref<InstanceType<typeof MentionsList>>()

  // Handle item selection
  const handleSelect = (item: MentionItem) => {
    props.command(item)
  }

  // Expose keyboard handler and selected item for parent extension
  defineExpose({
    handleKeyDown: (event: KeyboardEvent) => {
      return mentionsListRef.value?.handleKeyDown(event) || false
    },
    getSelectedItem: () => {
      return mentionsListRef.value?.getSelectedItem?.() || null
    },
  })
</script>

<template>
  <div class="suggestions-container">
    <MentionsList
      ref="mentionsListRef"
      :query="query"
      :on-select="handleSelect"
      :show-sections="true"
      empty-message="No courses, channels or events found"
    />
  </div>
</template>

<style scoped>
  .suggestions-container {
    /* Ensure dropdown appears above modal */
    z-index: 10000 !important;
    position: relative;

    /* Proper dropdown styling */
    background: var(--cp-brand-background);
    border: 1px solid var(--cp-border-600);
    border-radius: 8px;
    box-shadow:
      0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05);
    width: 20rem;
  }
</style>
